import { render } from "./BorderStarMapCircle.vue?vue&type=template&id=5cbcd5ba&lang=pug"
import script from "./BorderStarMapCircle.vue?vue&type=script&lang=js"
export * from "./BorderStarMapCircle.vue?vue&type=script&lang=js"

import "./BorderStarMapCircle.vue?vue&type=style&index=0&id=5cbcd5ba&lang=scss"

import exportComponent from "/Users/tranthang96/Sites/starmap/wp-content/plugins/nightsky-starmap-editor/app/frontend-editor/star-map/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__